import { useState } from 'react'
import DriversLicense from '../../../components/svg/drivers-license'
import FlatLock from '../../../components/svg/flat-lock'
import Checkbox from '../../../components/checkbox'
import { Button } from '../../../components/button'
import { GA_TRACKING_ID2 } from '../../../utils/g-tag'

export default function Consent({ onNext, onConsentRevoke }) {
  const [consent, setConsent] = useState({ value: false, error: false, submitAttempt: false })

  const handleConsentClick = () => {
    if (consent.isDirty && consent.value) onConsentRevoke()

    setConsent((prev) => ({
      ...prev,
      value: !prev.value,
      error: prev.submitAttempt && prev.value ? true : false,
      isDirty: true,
    }))
  }

  const handleNextClick = () => {
    try {
      //this can throw an exception when blocked by adblockers
      window.gtag('event', 'conversion', { send_to: GA_TRACKING_ID2 + '/eU34CL3CoooCELuM0rsB' })
    } catch {}

    if (!consent.value) setConsent((prev) => ({ ...prev, error: true, submitAttempt: true }))
    else onNext()
  }

  return (
    <div className='wrapper'>
      <h2 className='title'>Keeping privauto secure</h2>
      <p>
        Verifying your identity helps us check that you’re really you. This is one of the ways we
        keep privauto secure.
      </p>
      <div className='driversLicense flex '>
        <DriversLicense />
      </div>
      <h2>How our identity verification works</h2>
      <p>
        You’ll need to confirm the information we have from your account creation and fill in any
        gaps. We use this information to check against existing databases to confirm it’s really
        you.
      </p>
      <p>
        Our identity verification is carried out by{' '}
        <a href='Trulio.com' target='_blank'>
          Trulio.com
        </a>
        , one of the most trusted names in safe and secure identity verification. Your personal
        information is only used for the purposes of verifying your identity and we do not share or
        sell it to any other third parties.
      </p>
      <h2>Consent to confirm your identity</h2>
      <p>
        By clicking the check box below and selecting Next, you are confirming that you consent to
        verifying your identity.
      </p>
      <div className='consentCheck flex alignCenter'>
        <Checkbox
          checked={consent.value}
          onClick={handleConsentClick}
          className='checkbox'
          id='consentCheck'
          error={consent.error}
        />
        <label htmlFor='consentCheck' className='consentLabel'>
          Yes, I acknowledge and consent to the usage of information to confirm my identity.
        </label>
      </div>

      <span className='securityNotice flex alignCenter'>
        <FlatLock />
        <p>Your information isn’t shared with other people who use privauto.</p>
      </span>

      <div className='nextBtnContainer flex justifyEnd'>
        <Button onClick={handleNextClick}>Next</Button>
      </div>

      <style jsx>{`
        .wrapper {
          h2 {
            margin: 0 0 0.8rem;
            line-height: 3.6rem;
            font-size: 3.2rem;
          }

          p {
            margin: 0 0 1.6rem;
            line-height: 2.1rem;
            font-size: 1.4rem;
          }

          .driversLicense {
            margin: 1.5rem 0 4.37rem;

            :global(svg) {
              width: 20rem;
              height: 15rem;
            }
          }
        }

        .consentCheck {
          margin: 2.5rem 0 0;

          :global(.checkbox) {
            margin: 0.3rem 1rem 0 0;
          }

          .consentLabel {
            font-size: 1.6rem;
            font-weight: 700;
          }
        }

        .securityNotice {
          margin: 8.7rem auto 0;
          width: 100%;

          :global(svg) {
            margin: 0 1.16rem 0 0;
          }

          p {
            margin: 0;
            font-size: 1.4rem;
            font-style: italic;
          }
        }

        .nextBtnContainer {
          margin: 1.3rem 0 0;
        }

        @media (max-width: 1024px) {
          .wrapper {
            h2 {
              margin: 0 0 0.9rem;
              line-height: 2.4rem;
              font-size: 1.8rem;
            }

            p {
              margin: 0 0 1.3rem;
              line-height: 1.9rem;
              font-size: 1.4rem;
            }

            .driversLicense {
              margin: 0.06rem 0 0.83rem;
              justify-content: center;

              :global(svg) {
                width: auto;
                height: auto;
              }
            }
          }

          .consentCheck {
            margin: 1.4rem 0 0;

            .checkbox {
              min-width: 2rem;
              height: 2rem;
              margin: 0.3rem 1.6rem 0 0;
              appearance: checkbox;
              border: 0.2rem solid var(--secondary-button-bg);

              &.error {
                border: 0.2rem solid var(--alert-color);
              }
            }

            .consentLabel {
              font-size: 1.4rem;
            }
          }

          .securityNotice {
            margin: 3.3rem auto 0;
            width: fit-content;

            :global(svg) {
              margin: 0 0.72rem 0 0;
            }

            p {
              margin: 0;
              font-size: 1.2rem;
              font-style: italic;
            }
          }

          .nextBtnContainer {
            margin: 3rem 0 0;

            :global(button) {
              width: 100%;
            }
          }
        }
      `}</style>
    </div>
  )
}
